module.exports = __webpack_public_path__ + "img/goods11_6.74e1c19c.jpg";